import { FC, useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { setAbn, setActivSub, setArrSub, setBalance, setDateBonusParty, setDateEndSub, setDateLesson, setDateLessonFull, setIsFire, setNameStudent, setPrice, setPubDate, setQuantity, setStatus, setUserData } from "../../redux/slices/profileSlice/profileSlice";
import mainLogo from './../../img/logo_main.png';
import './Profile.scss';
import LatinaController from "../../API/LatinaController";

interface ProfileProps {

}

const Profile: FC<ProfileProps> = () => {

  let navigate = useNavigate();

  const dispatch = useAppDispatch()
  const nameStudent = useAppSelector((state) => state.profile.nameStudent)
  const subscrip = useAppSelector((state) => state.profile.subscrip)
  const balance = useAppSelector((state) => state.profile.balance)
  const pubDate = useAppSelector((state) => state.profile.pubDate)
  const dateLesson = useAppSelector((state) => state.profile.dateLesson)
  const dateBonusParty = useAppSelector((state) => state.profile.dateBonusParty)
  const price = useAppSelector((state) => state.profile.price)
  const isFire = useAppSelector((state) => state.profile.isFire)
  const quantity = useAppSelector((state) => state.profile.quantity)
  const dateLessonFull = useAppSelector((state) => state.profile.dateLessonFull)
  const status = useAppSelector((state) => state.profile.status)
  const arrSub = useAppSelector((state) => state.profile.arrSub)
  const activSub = useAppSelector((state) => state.profile.activSub)
  const dateEnd = useAppSelector((state) => state.profile.dateEnd)
  const userData = useAppSelector((state) => state.profile.userData)

  const idStudent = useAppSelector((state) => state.usersR.user.id)
  const token = useAppSelector((state) => state.usersR.token)

  const priceSub = process.env.REACT_APP_PRICE_SUB ? Number(process.env.REACT_APP_PRICE_SUB) : 0
  const priceFire = process.env.REACT_APP_PRICE_FIRE ? Number(process.env.REACT_APP_PRICE_FIRE) : 0
  const priceHoreo = process.env.REACT_APP_PRICE_HOREO ? Number(process.env.REACT_APP_PRICE_HOREO) : 0



  useEffect(() => {


    const dataSend = {
      id: Number(idStudent)
    }

    LatinaController.studentOne(dataSend)
      .then(res => {
        const nameData = JSON.parse(res.info)
        dispatch(setNameStudent(nameData.info))

        const arr = res.subscriptions.map((val: any) => {
          return val.id
        })
        const arrJoin = res.subscriptions.filter((val: any) => val.balance > 0 && val.isActive).map((val: any) => {
          return val.id
        })

        dispatch(setArrSub(arr))
        dispatch(setAbn(arrJoin.join(',')))

        const data = res.subscriptions[0]

        let statusTemp = true
        if (data.isFire) {
          const oldDate = new Date(Date.parse(data.dateBegin))

          let dateKorrekt = 0
          if (process.env.REACT_APP_KORREKT_DATE) {
            dateKorrekt = Number(process.env.REACT_APP_KORREKT_DATE)
          }

          let newDate = new Date(oldDate.setMonth(oldDate.getMonth() + 1))
          let newDate2 = new Date(newDate.setDate(newDate.getDate() + dateKorrekt))

          dispatch(setDateEndSub(newDate2.toISOString()))

          const oneDate = new Date()

          if (oneDate.getTime() > newDate2.getTime()) {
            statusTemp = false
          }

        } else {
          const oldDate = new Date(Date.parse(data.dateBegin))

          let newDate = new Date(oldDate.setFullYear(oldDate.getFullYear() + 1))

          dispatch(setDateEndSub(newDate.toISOString()))

          const oneDate = new Date()

          if (oneDate.getTime() > newDate.getTime()) {
            statusTemp = false
          }
        }

        if (data.status == false) {
          statusTemp = false
        }



        dispatch(setBalance(data.balance))
        dispatch(setStatus(statusTemp))
        dispatch(setPubDate(data.dateBegin))
        dispatch(setPrice(data.price))
        dispatch(setIsFire(data.isFire))
        dispatch(setQuantity(data.quantity))

        const nameData2 = JSON.parse(data.info)

        dispatch(setDateLessonFull(nameData2.lessons))
        dispatch(setNameStudent(nameData2.info))
        if (nameData.date) {
          dispatch(setDateLesson(nameData2.date))
        }

        if (nameData2.dateBonusParty) {
          dispatch(setDateBonusParty(nameData2.dateBonusParty))

        } else {
          dispatch(setDateBonusParty([]))
        }

        const subObj: any = {}

        res.subscriptions.map((val: any) => {
          subObj[val.id] = val
        })

        res.subscriptions = subObj

        dispatch(setUserData(res))
        return res
      })
  }, []);


  const onSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const value = (event.target.value);
    dispatch(setActivSub(Number(value)))

    const res = userData

    const data = res.subscriptions[Number(value)]


    let statusTemp = true
    if (data.isFire) {
      const oldDate = new Date(Date.parse(data.dateBegin))

      let dateKorrekt = 0
      if (process.env.REACT_APP_KORREKT_DATE) {
        dateKorrekt = Number(process.env.REACT_APP_KORREKT_DATE)
      }

      let newDate = new Date(oldDate.setMonth(oldDate.getMonth() + 1))
      let newDate2 = new Date(newDate.setDate(newDate.getDate() + dateKorrekt))

      dispatch(setDateEndSub(newDate2.toISOString()))

      const oneDate = new Date()

      if (oneDate.getTime() > newDate2.getTime()) {
        statusTemp = false
      }

    } else {
      const oldDate = new Date(Date.parse(data.dateBegin))

      let newDate = new Date(oldDate.setFullYear(oldDate.getFullYear() + 1))

      dispatch(setDateEndSub(newDate.toISOString()))

      const oneDate = new Date()

      if (oneDate.getTime() > newDate.getTime()) {
        statusTemp = false
      }
    }

    if (data.status == false) {
      statusTemp = false
    }

    dispatch(setBalance(data.balance))
    dispatch(setStatus(statusTemp))
    dispatch(setPubDate(data.dateBegin))
    dispatch(setPrice(data.price))
    dispatch(setIsFire(data.isFire))
    dispatch(setQuantity(data.quantity))

    if (data.info) {
      const nameData = JSON.parse(data.info)

      dispatch(setDateLessonFull(nameData.lessons))
      dispatch(setNameStudent(nameData.info))
      if (nameData.date) {
        dispatch(setDateLesson(nameData.date))
      } else {
        dispatch(setDateLesson(['']))
      }

      if (nameData.dateBonusParty) {
        dispatch(setDateBonusParty(nameData.dateBonusParty))

      } else {
        dispatch(setDateBonusParty([]))
      }

    } else {
      dispatch(setDateLesson(['']))
    }
  }



  return (
    <>
      <div className="profile">
        <div className="profile__header">
          <img className="logo" src={mainLogo} alt='логотип' />
        </div>
        <div className='profile__content'>
          <div className="profile__content-title">
            <p>
              Добро пожаловать в личный кабинет
            </p>
            <p style={{ maxWidth: '300px', wordBreak: 'break-word' }}>
              {nameStudent}
            </p>
          </div>
          <div className="profile__subscriptions">
            <p>
              Открытые абонементы:
            </p>
            <p style={{ maxWidth: '300px', wordBreak: 'break-all' }}>
              {subscrip}
            </p>
          </div>
          <div className="profile__subscriptions-selector">
            <p>
              Выберите абонемент из списка:
            </p>

            <select className="s-select" name={`activAbn`} value={activSub} onChange={onSelect} >
              {arrSub ? arrSub.map((it: any, ind: any) => <option className="s-select__option" value={it} key={ind}>{it}</option>) : <option >{'старт'}</option>}
            </select>

          </div>

          <div className="profile__balance">
            <p>
              Статус:
            </p>
            <p>
              {status ? 'действующий' : 'не действует'}
            </p>
          </div>


          <div className="profile__classes-left">
            <p>
              Кол-во оставшихся занятий:
            </p>
            <p>
              {balance} из {quantity}
            </p>
          </div>
          <div className="profile__subscription-type">
            <p>
              Тип абонемента:
            </p>
            <p>
              {isFire ? 'сгораемый' : 'годовой'}
            </p>
          </div>
          <div className="profile__subscription-created-at">
            <p>
              Дата покупки:
            </p>
            <p>
              {pubDate.substring(0, 10)}
            </p>
          </div>
          <div className="profile__subscription-due-to">
            <p>
              Дата окончания:
            </p>
            <p>
              {dateEnd.substring(0, 10)}
            </p>
          </div>


          {isFire ?
            <>
              <div className="profile__bonus">
                <p>
                  Бонусная вечеринка:
                </p>
                {dateBonusParty.length > 0 ? dateBonusParty.map((it, ind) => <p key={ind}>{it.substring(0, 10)}</p>) : '-'}
              </div>
            </>
            : <></>
          }
          <div className="profile__lessons-used" style={{ maxWidth: '300px', wordBreak: 'break-all' }}>
            <p>
              Даты посещений:
            </p>
            {dateLessonFull && dateLessonFull.length > 0 ? (
              dateLessonFull.map((it, ind) => <p key={ind}>{it.date.substring(0, 10)}{' '}{it.name}</p>)
            ) : (
              dateLesson.map((it, ind) => <p key={ind}>{it}</p>)

            )
            }

          </div>
        </div>
      </div>
    </>
  )
}

export default Profile;
